import axios from "axios";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import { connect } from "react-redux";
import React, { Component } from "react";
import { Card, CardBody, CardHeader, Col } from "reactstrap";
import AUTPriceTable from "../common/AUTPriceTable";
import CustomerInfoTable from "../common/CustomerInfoTable";
import "./tabViewaut.css";
import Swal from "sweetalert2";
import { configuration } from "../../appConfig";
import DuplicateVinModal from "../DuplicateVinModal";

// axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');
const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export class TabViewAUT extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: "",
      words: {},
      duplicateVinModal: false,
      IsPriceTableUpdated: false,
      selectedPartnerIdList: [],
      selectedPartnerId: "",
      Authorized: false,
    };
  }

  componentDidMount = () => {
    this.getLang();
    this.getOrderId();
  };

  getLang = () => {
    const base_url = window.location.origin;
    axios.get(`${base_url}/lang.json`).then((res) => {
      let lang = localStorage.getItem("lang");
      this.setState({ lang: lang });
      this.setState({ words: res.data });
    });
  };
  getOrderId = () => {
    axios
      .get(configuration.getData, {
        params: {
          vin: localStorage.getItem("selectedFile"),
          partnerId: localStorage.getItem("partnerId"),
        },
      })
      .then((res) => {
        this.setState({
          Authorized: res.data.Authorized,
          IsPriceTableUpdated: res.data.IsPriceTableUpdated || false,
        });
      })
      .catch((err) => console.log(err));
  };

  lang = (word) => {
    const { lang, words } = this.state;
    return words[word] ? words[word][lang] : word;
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else return null;
  }
  handleRestoreJson = () => {
    this.setState({
      restoreDataloading: true,
    });
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    let url = `${configuration.restoreJsonBackup}?partnerId=${partnerId}&vin=${vin}`;
    axios
      .get(url)
      .then((res) => {
        if (res.data.status === 200) {
          Toast.fire({
            type: "success",
            title: "JSON restored successfully!",
          });
          this.setState({
            restoreDataloading: false,
          });
          setTimeout(() => {
            window.location.reload();
          }, 5000);
        } else if (res.data.status === 400) {
          this.setState({
            restoreDataloading: false,
          });
          Toast.fire({
            type: "error",
            title: "Failed to restore JSON!",
          });
        } else if (res.data.status === 404) {
          this.setState({
            restoreDataloading: false,
          });
          Toast.fire({
            type: "error",
            title: "JSON backup not found!",
          });
        }
      })
      .catch((err) => {
        this.setState({
          restoreDataloading: false,
        });
        Toast.fire({
          type: "error",
          title: "Something went wrong!",
        });
      });
  };
  openDuplicateVinModal = (clearValue) => {
    this.setState({ duplicateVinModal: !this.state.duplicateVinModal });
    if (clearValue) {
      this.setState({selectedPartnerId : ""})
    }
    if (
      this.props.selectedPartnerId &&
      this.props.selectedPartnerId.length > 0
    ) {
      const newOptions = this.props.selectedPartnerId.map((val) => ({
        label: val,
        value: val,
      }));

      this.setState({ selectedPartnerIdList: newOptions });
    }
  };

  handleSelectedPartnerId = (selectedOptions) => {
    this.setState({ selectedPartnerId: selectedOptions });
  };

  render() {
    const vin = localStorage.getItem("selectedFile");
    const showDuplicateVinBtn = this.props.isDuplicateVin == 1 ? true : false;
    const {
      Authorized,
      IsPriceTableUpdated,
      duplicateVinModal,
      selectedPartnerIdList,
      selectedPartnerId,
    } = this.state;
    return (
      <div className="animated fadeIn aut_main_tab_wrapper">
        <Col xs="12" sm="12" className="p-2">
          {/* <div className="container-fluid card_heading_main_bg">
                <div className="row">
                    <div className="col-12 p-0">
                        <div className="container-fluid">
                            <div className="row align-items-center p-0">
                                <div className="col-lg-6 col-md-6 col-sm-6 col-12 mt-sm-10">
                                    <small> <span>{this.lang("VIN Number")} :</span> {vin}</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
          <Card className="print_button_card">
            <CardHeader>
              <div className="container-fluid">
                <div className="row align-items-center p-0">
                  <div className="col-lg-3 col-md-6 col-sm-6 col-12 mt-sm-10">
                    <small>
                      {" "}
                      <span>{this.lang("VIN Number")} :</span>{" "}
                      {localStorage.getItem("selectedFile")}
                    </small>
                  </div>
                  <div className="col-lg-9 col-md-8 col-sm-12 col-12 mt-sm-10 p-0">
                    <div className="d-flex align-items-center justify-content-end flex-wrap btn-position">
                      {showDuplicateVinBtn && (
                        <button
                          disabled={Authorized || !IsPriceTableUpdated}
                          className="glass btn mx-3 btn-lg btn-danger mr-1"
                          onClick={() => this.openDuplicateVinModal()}
                        >
                          {this.lang("Duplicate VIN")}
                        </button>
                      )}
                      <button
                        className="glass btn mx-3 btn-lg btn-danger pull-right mr-1"
                        onClick={() => this.handleRestoreJson()}
                        disabled={Authorized}
                      >
                        {this.lang("Restore Data")}
                      </button>
                    </div>
                  </div>
                  <div className="col-6 text-right"></div>
                </div>
              </div>
            </CardHeader>
          </Card>
          <Card>
            <CardBody>
              <div className="row p-0">
                <CustomerInfoTable viewType="TabView" />
                <AUTPriceTable isTabView={true} viewType="TabView" />
              </div>
            </CardBody>
          </Card>
        </Col>
        <DuplicateVinModal 
        duplicateVinModal={duplicateVinModal}
        openDuplicateVinModal={this.openDuplicateVinModal}
        selectedPartnerIdList={selectedPartnerIdList}
        handleSelectedPartnerId={this.handleSelectedPartnerId}
        selectedPartnerId={selectedPartnerId}
        lang={this.lang}
        />
      </div>
    );
  }
}

const mapStateToProps = (props) => {
  return {
    selectedPartnerId: props.selectedPartnerId.duplicateSelectedPartnerId,
    isDuplicateVin: props.selectedPartnerId.isDuplicateVin,
  };
};
export default compose(connect(mapStateToProps), withRouter)(TabViewAUT);
